import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { canPerformAnyAction } from '~src/resourceActions/selectors/ResourceActionsSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { areAllSelectedUsersServerAdmins, isSingleSelectSiteUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { siteUserEditSiteRole } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserSiteRoleAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserSiteRole,
  translateName: Messages.siteRole_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
    const passesCommonChecks = targetItems.length > 0
      && !isSingleSelectSiteUserGuest(targetItems)
      && (!areAllSelectedUsersServerAdmins(targetItems) || SessionUserSelectors.isSessionServerAdmin(state));

    const hasAccess = SessionUserSelectors.canManageUsers(state)
      || (SessionServerSelectors.isAdminProfilesEnabledOnServer(state) && canPerformAnyAction(state, 'User', ['CHANGE_SITE_ROLE']));

    return passesCommonChecks && hasAccess;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditSiteRole(targetItems)
};
